<template>
  <div class="admin_main">
    <div class="admin_container">
      <table-with-filter
        style="width: 100%"
        :is-filterable="false"
        fixed-header
        :height="$vuetify.breakpoint.height - 160"
        hide-default-footer
        :headers="headers"
        :items="items"
      >
        <template #no-data>
          <td colspan="100%" class="pt-2 pb-2">
            <div class="d-flex justify-center">
              <v-btn :loading="loading" @click="test" color="primary">{{
                $t("start")
              }}</v-btn>
            </div>
          </td>
        </template>
        <template #prepend:body v-if="items.length != 0">
          <tr>
            <td colspan="100%" class="pt-2 pb-2">
              <div class="d-flex justify-center">
                <v-btn :loading="loading" @click="test" color="primary">{{
                  $t("reload")
                }}</v-btn>
              </div>
            </td>
          </tr>
        </template>
      </table-with-filter>
    </div>
  </div>
</template>

<script>
import TableWithFilter from "@/components/ui/table/TableWithFilter";

export default {
  name: "reindex",
  components: { TableWithFilter },
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("warnings"), value: "warn" },
        { text: this.$t("error"), value: "error" },
      ];
    },
  },
  methods: {
    async test() {
      try {
        const {
          data: { error, warn },
        } = await this.$http.post("testing/system/start");
        let arr = [];
        let len = warn.length > error.length ? warn.length : error.length;
        for (let i = 0; i < len; i++) {
          arr.push({
            warn: warn[i] || "",
            error: error[i] || "",
          });
        }
        this.items = arr;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
};
</script>

<style scoped></style>
